import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=d85a054c&scoped=true&"
import script from "./BaseTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTabs.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=d85a054c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a054c",
  null
  
)

export default component.exports